import moment from 'moment';

export const showFormattedDate = (date, dayNum) =>
  date
    ? moment(date)
        .add(Number(dayNum) - 1, 'd')
        .format('MMMM DD, YYYY')
    : null;



// WEBPACK FOOTER //
// ./src/screens/Trek/Self-Guided/Review/utils.js